<template>
  <div class="continer">
    <div class="height"></div>
    <div class="top">
      <div class="flex alitm_center top_text">
        <p>商品评价</p>
        <span>({{goods_eva_num}}人评价）</span>
      </div>
      <div class="flex tabs">
        <p
          :class="[cur == item.id ? 'active' : '']"
          v-for="item in tabs"
          :key="item.id"
          @click="change(item.id)"
        >{{item.name}}</p>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="evaluate">
        <div class="eval_content">
          <div class="eval_list" v-for="item in list" :key="item.id">
            <div class="eval_sim flex">
              <div class="flex">
                <img :src="item.avatar" alt />
                <div>
                  <div class="uate_title">{{item.nick_name}}</div>
                  <van-rate v-model="item.goods_score" readonly />
                </div>
              </div>
              <p>{{item.verify_time_text}}</p>
            </div>
            <div class="uate_content">{{item.content}}</div>
            <div class="uate_img flex">
              <img
                :src="titem"
                v-for="(titem,index) in item.image_list"
                :key="index"
                @click="openImagesFg(item.image_list,index)"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-image-preview :startPosition="canvasImg" v-model="isShowImgs" :images="images"></van-image-preview>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 2,
      tabs: [
        { name: '4-5星', id: 1 },
        { name: '2-3星', id: 2 },
        { name: '1星', id: 3 },
      ],
      cur: 1,
      list: [],
      loading: false,
      finished: false,
      page: 0,
      goods_eva_ratio: '',
      goods_eva_num: '',
      isShowImgs: false,
      images: [],
      canvasImg: 0,
    }
  },
  methods: {
    openImagesFg(e, index) {
      this.canvasImg = index
      console.log(e)
      this.images = e
      this.isShowImgs = true
    },
    onLoad() {
      this.page++
      this.goodsEvaList(this.list)
    },
    goodsEvaList(list) {
      this.http('ClientOrderEvaluate.goodsEvaList', {
        goods_id: this.$route.query.goods_id,
        score_type: this.cur,
        page: this.page,
        limit: 20,
      }).then((e) => {
        console.log(e)
        this.list = [...list, ...e.content.list]
        this.loading = false
        this.finished = this.list.length == e.content.count
        this.goods_eva_ratio = e.content.goods_eva_ratio
        this.goods_eva_num = e.content.goods_eva_num
      })
    },
    change(id) {
      this.cur = id
      this.page = 1
      this.goodsEvaList((this.list = []))
    },
  },
}
</script>

<style scoped lang="scss">
.continer {
  min-height: 100vh;
  background: rgba(247, 248, 250, 1);
}
.alitm_center {
  align-items: center;
}
.just_bettw {
  justify-content: space-between;
}
//评论
.evaluate {
  background: #ffffff;
  .evaluate_top {
    padding: 30px 32px;
    border-bottom: 1px solid rgba(241, 241, 241, 1);
    justify-content: space-between;
    .evaluate_fl {
      .eval_title {
        font-size: 28px;
        color: #333333;
      }
      .eval_people {
        font-size: 26px;
        color: #999999;
        margin-left: 20px;
      }
    }
    .evaluate_fr {
      .eval_good {
        font-size: 28px;
        color: #999999;
        margin-right: 10px;
      }
      .eval_num {
        font-size: 28px;
        color: #ee0a24;
      }
    }
  }
  .eval_content {
    font-size: 22px;
    color: #666666;
    line-height: 36px;
    margin-bottom: 160px;
    .eval_list {
      border-bottom: 1px solid rgba(241, 241, 241, 1);
      padding: 40px 30px 30px;
    }
    .eval_list:nth-child(2) {
      border-bottom: none !important;
    }
    .enval_btn {
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 30px;
      border: 1px solid #979797;
      font-size: 24px;
      color: #999999;
      margin: 0 auto;
    }
    .eval_sim {
      margin-top: 16px;
      justify-content: space-between;
      align-items: flex-end;
      img {
        width: 88px;
        height: 88px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .uate_title {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 26px;
        color: #333333;
        margin-bottom: 10px;
      }
    }
    .uate_content {
      margin-top: 20px;
    }
    .uate_img {
      margin-top: 20px;
      img {
        width: 110px;
        height: 110px;
        border-radius: 20px;
        margin-right: 20px;
      }
    }
  }
}
.height {
  height: 20px;
}
.top {
  background: #ffffff;
  margin-bottom: 20px;
  padding: 30px 30px 24px 40px;
  .top_text {
    p {
      font-size: 28px;
      color: #333333;
      line-height: 40px;
    }
    span {
      font-size: 26px;
      color: #999999;
      line-height: 37px;
      margin-left: 20px;
    }
  }
}
.tabs {
  justify-content: space-around;
  margin-top: 25px;
  p {
    width: 150px;
    height: 50px;
    line-height: 50px;
    background: #ffecee;
    border-radius: 30px;
    font-size: 28px;
    color: #ee0a24;
    text-align: center;
  }
}
.active {
  background: rgba(238, 10, 36, 1) !important;
  color: rgba(255, 255, 255, 1) !important;
}
</style>